<div class="inactivity-warning-overlay" *ngIf="visible">
  <div
    class="inactivity-warning-dialog"
    role="alertdialog"
    aria-modal="true"
    aria-labelledby="inactivity-warning-title"
  >
    <h4 id="inactivity-warning-title">Session timeout</h4>
    <p>
      No activity has been tracked for <strong>{{ inactivityDurationLabel }}</strong>.
      You will be logged out in <strong>{{ secondsRemaining }}</strong>
      {{ secondsRemaining === 1 ? 'second' : 'seconds' }}.
    </p>
    <p>Do you want to stay logged in?</p>
    <div class="inactivity-warning-actions">
      <button type="button" class="inactivity-stay-btn" (click)="stayLoggedIn()">
        Stay logged in
      </button>
    </div>
  </div>
</div>
